module.exports = __webpack_public_path__ + "static/media/linkedin_icon.be73e37a.svg";